app.service('promotionService', [
  '$http',
  function ($http) {
    this.checkRedeemGiftPromotionExist = function () {
      return $http({
        url: 'api/promotions/is_redeem_gift_promotion_exist',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
    };
    this.getCoupons = function (scope) {
      return $http({
        method: 'GET',
        url: `/api/users/promotions?show_coupon=true&usage=coupon&scope=${scope}`,
      });
    };
  },
]);
